function attachQuickAddListeners() {
  // Handle clicks at the product-card level to block navigation
  document.querySelectorAll('product-card:not([data-quick-add-listener])').forEach(function(card) {
    card.setAttribute('data-quick-add-listener', 'true');
    card.addEventListener('click', function(e) {
      var btn = e.target.closest('.quick-add__size-btn');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var variantId = parseInt(btn.getAttribute('data-variant-id'));
      var original = btn.textContent.trim();
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: variantId, quantity: 1})
      }).then(function(r) {
        return r.json();
      }).then(function(data) {
        btn.textContent = '✓';
        setTimeout(function() { btn.textContent = original; }, 1500);
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          var event = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'quick-add',
              data: {
                itemCount: cart.item_count,
                source: 'quick-add'
              }
            }
          });
          document.dispatchEvent(event);
        });
      }).catch(function(err) {
        console.error('Cart add failed:', err);
        btn.textContent = original;
      });
    }, true);
  });
}

document.addEventListener('DOMContentLoaded', attachQuickAddListeners);
var observer = new MutationObserver(attachQuickAddListeners);
observer.observe(document.body, { childList: true, subtree: true });